import { render, staticRenderFns } from "./LinksForWardeningPopup.vue?vue&type=template&id=098161a2&scoped=true"
import script from "./LinksForWardeningPopup.vue?vue&type=script&lang=js"
export * from "./LinksForWardeningPopup.vue?vue&type=script&lang=js"
import style0 from "./LinksForWardeningPopup.vue?vue&type=style&index=0&id=098161a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098161a2",
  null
  
)

export default component.exports